// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { VulnerableBuildingsParams } from "./VulnerableBuildingsParams";
import {
  VulnerableBuildingsParamsFromJSON,
  VulnerableBuildingsParamsFromJSONTyped,
  VulnerableBuildingsParamsToJSON,
  VulnerableBuildingsParamsToJSONTyped,
} from "./VulnerableBuildingsParams";
import type { OGC3DTilesParams } from "./OGC3DTilesParams";
import {
  OGC3DTilesParamsFromJSON,
  OGC3DTilesParamsFromJSONTyped,
  OGC3DTilesParamsToJSON,
  OGC3DTilesParamsToJSONTyped,
} from "./OGC3DTilesParams";

/**
 *
 * @export
 * @interface Params
 */
export interface Params {
  /**
   *
   */
  interval?: number;
  /**
   *
   */
  maxNumberFrames?: number;
  /**
   *
   */
  method?: ParamsMethodEnum;
  /**
   *
   */
  buildingsResultCode?: string;
}

/**
 * @export
 */
export const ParamsMethodEnum = {
  Dgbc: "dgbc",
  Advanced: "advanced",
} as const;
export type ParamsMethodEnum = (typeof ParamsMethodEnum)[keyof typeof ParamsMethodEnum];

/**
 * Check if a given object implements the Params interface.
 */
export function instanceOfParams(value: object): value is Params {
  return true;
}

export function ParamsFromJSON(json: any): Params {
  return ParamsFromJSONTyped(json, false);
}

export function ParamsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Params {
  if (json == null) {
    return json;
  }
  return {
    interval: json["interval"] == null ? undefined : json["interval"],
    maxNumberFrames: json["max_number_frames"] == null ? undefined : json["max_number_frames"],
    method: json["method"] == null ? undefined : json["method"],
    buildingsResultCode:
      json["buildings_result_code"] == null ? undefined : json["buildings_result_code"],
  };
}

export function ParamsToJSON(json: any): Params {
  return ParamsToJSONTyped(json, false);
}

export function ParamsToJSONTyped(
  value?: Params | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    interval: value["interval"],
    max_number_frames: value["maxNumberFrames"],
    method: value["method"],
    buildings_result_code: value["buildingsResultCode"],
  };
}
